import { Instagram } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";

export default function IGFeed({ home, settings }) {
  const images = home.ig_images || [];
  const ig = settings?.instagram_url || "https://www.instagram.com/thebridesofindia";
  if (!images.length) return null;

  return (
    <section data-testid="instagram-section" className="bg-blush py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <Reveal>
              <Eyebrow gold={false}>On Instagram</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl text-ink">@thebridesofindia</h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-4 max-w-lg text-neutral-600">
                Daily bridal inspiration, celebrity coverage and behind-the-scenes magic from India and the diaspora.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <a
              href={ig}
              target="_blank"
              rel="noreferrer"
              data-testid="ig-follow-button"
              className="group inline-flex items-center gap-3 bg-ink text-cream rounded-full px-7 py-3.5 text-xs uppercase tracking-[0.25em] font-semibold hover:bg-rose hover:text-ink transition-colors duration-300"
            >
              <Instagram size={16} />
              Follow Along
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3">
          {images.slice(0, 6).map((src, i) => (
            <Reveal key={i} delay={0.05 * i}>
              <a
                href={ig}
                target="_blank"
                rel="noreferrer"
                data-testid={`ig-tile-${i}`}
                className="group relative block aspect-square overflow-hidden rounded-2xl md:rounded-[1.5rem]"
              >
                <img
                  src={src}
                  alt="The Brides of India on Instagram"
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-ink/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                  <Instagram size={22} className="text-cream" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
